import React from 'react';
import { Button, ButtonAsAnchorProps } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { communityNavSubHeaderDataHooks } from '../CommunityNavSubHeader.dataHooks';

interface Props {
  buttonProps?: Partial<ButtonAsAnchorProps<any>>;
  isSmallLabel?: boolean;
}

const DiscordButton = ({ buttonProps = {}, isSmallLabel }: Props) => {
  const { t } = useTranslation();

  const label = isSmallLabel
    ? 'marketplace.community-nav-sub-header.discord-label-small'
    : 'marketplace.community-nav-sub-header.discord-label';

  return (
    <Button
      as="a"
      target="_blank"
      href={t('marketplace.community-nav-sub-header.discord-link')}
      size="small"
      dataHook={communityNavSubHeaderDataHooks.action()}
      {...buttonProps}
    >
      {t(label)}
    </Button>
  );
};

export default DiscordButton;
